import React, { createContext, useContext, useReducer } from 'react';


const adminState = (
  localStorage.getItem('adminState')
    ?
  JSON.parse(localStorage.getItem('adminState'))
    :
  {
    accountColumns: {
      id: { hide: true, order: 1, width: 100 },
      isActivated: { hide: false, order: 2, width: 100 },
      email: { hide: false, order: 3, width: 350 },
      contactEmail: { hide: false, order: 4, width: 350 },
      latestConnection: { hide: false, order: 5, width: 250 },
      role: { hide: false, order: 6, width: 275 },
      group: { hide: false, order: 7, width: 300 },
      location: { hide: false, order: 8, width: 300 },      
      actions: { hide: false, order: 9, width: 150 }
    },
    groupColumns: {
      id: { hide: true, order: 1, width: 100 },
      favorite: { hide: false, order: 2, width: 50 },
      name: { hide: false, order: 3, width: 900 },
      management: { hide: false, order: 4, width: 475 },
      /*wipeReport: { hide: true, order: 5, width: 225 },
      pageSize: { hide: true, order: 6, width: 225 },
      actions: { hide: false, order: 7, width: 125 }*/
      actions: { hide: false, order: 8, width: 150 }
    },
    locationColumns: {
      id: { hide: true, order: 1, width: 100 },
      enabled: { hide: false, order: 2, width: 100 },
      deactivation: { hide: true, order: 3, width: 150 },
      group: { hide: false, order: 4, width: 300 },
      label: { hide: false, order: 5, width: 400 },
      last: { hide: false, order: 6, width: 300 },
      name: { hide: false, order: 7, width: 350 },
      mceLocation: { hide: true, order: 8, width: 400 },
      mceProductKey: { hide: true, order: 9, width: 300 },
      mceExpiration: { hide: true, order: 10, width: 200 },
      sdsExpiration: { hide: true, order: 11, width: 200 },
      login: { hide: true, order: 12, width: 150 },
      password: { hide: true, order: 13, width: 150 },
      ip: { hide: true, order: 14, width: 150 },
      port: { hide: true, order: 15, width: 100 },
      dbType: { hide: false, order: 16, width: 125 },
      activityPc: { hide: false, order: 17, width: 125 },
      activityMobile: { hide: false, order: 18, width: 125 },
      actions: { hide: false, order: 19, width: 150 }
    },
    reportColumns: {
      id: { hide: true, order: 1, width: 100 },
      enabled: { hide: true, order: 2, width: 100 },
      favorite: { hide: false, order: 3, width: 50 },
      name: { hide: false, order: 4, width: 250 },
      template: { hide: false, order: 5, width: 250 },
      format: { hide: false, order: 6, width: 140 },
      language: { hide: false, order: 7, width: 140 },
      pageSize: { hide: false, order: 8, width: 140 },
      dateFormat: { hide: false, order: 9, width: 200 },
      outputFileName: { hide: false, order: 10, width: 300 },
      creator: { hide: false, order: 11, width: 200 },
      sharingOptions: { hide: false, order: 12, width: 300 },     
      group: { hide: false, order: 13, width: 200 },   
      actions: { hide: false, order: 14, width: 150 }      
    },
    scenarioColumns: { 
      id: { hide: true, order: 1, width: 100 },
      name: { hide: false, order: 2, width: 350 },
      creator: { hide: false, order: 3, width: 200 },
      sharedWith: { hide: false, order: 4, width: 300 },
      group: { hide: false, order: 5, width: 200 },
      creationDate: { hide: false, order: 6, width: 150 },
      lastEditionUser: { hide: false, order: 7, width: 350 },
      lastEditionDate: { hide: false, order: 8, width: 150 },
      deviceType: { hide: false, order: 9, width: 100 },
      numberOfModules: { hide: true, order: 10, width: 100 },
      actions: { hide: false, order: 11, width: 150 }
    }
  }
);

const AdminContext = createContext();
export const AdminProvider = ({ reducer, children }) => (
  <AdminContext.Provider value={useReducer(reducer, adminState)}>
    {children}
  </AdminContext.Provider>
);

export const useAdminContext = () => useContext(AdminContext);
